import { ButtonEl, ButtonFieldWrapper, ButtonGroup, Title } from "../DetailGraphSelector.styled";

export default function ButtonFieldView({ onActionRouteToPage }) {
    return (
        <ButtonFieldWrapper>
            <div>
                <Title>상품 순위 확인</Title>
                <ButtonGroup>
                    <ButtonEl onClick={() => onActionRouteToPage('/sales-analysis/sales-channel/best-product')}>판매스토어 별</ButtonEl>
                </ButtonGroup>
            </div>
        </ButtonFieldWrapper>
    )
}